<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <select
      class="form-control show-tick"
      :id="vesselKey"
      v-model="inputValue"
      @input="change"
      @change="emit"
      @blur="emit"
      :disabled="disabled"
    >
      <option
        v-for="personalNationality in availableItems()"
        v-bind:key="personalNationality.id"
        :value="personalNationality.id"
      >{{ personalNationality.full_name }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <label id="form-pass-flag-img" style="position: absolute" >
      <img class='country-image' style="top: -24px; right: -235px;" v-if="passFlag" :src="passFlag" alt=""/>
    </label>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'

export default {
  name: 'VesselFlagInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Флаг судна'
    },

    iso2: {
      type: String,
      default: null
    },

    iso3: {
      type: String,
      default: null
    },

    passFlag: {
      type: String,
      default: null
    },

    inputName: {
      default: 'flag'
    },

    items: {
      type: [Array, Object],
      default: () => []
    },

    vesselId: {
      type: [Number],
      default: null
    }
  },

  computed: {
    vesselKey () {
      return `form-pass-flag-${this.vesselId}`
    },

    inputError () {
      return this.hasInputErrors ? 'Выберите флаг судна' : null
    },

    hasInputErrors () {
      return this.errors.vessels !== undefined && this.errors.vessels[this.vesselId] && this.errors.vessels[this.vesselId].find((err) => err === 'flag')
    }
  },

  methods: {
    change ($event, item) {
      this.emit($event)
    },

    availableItems() {
      return this.isView ? this.items : this.items.filter((item) => Number(item.vessel_flag) === 1)
    }
  }
}
</script>
